/**
 * Constants for useHistoryList hook
 */

import { SortDirection } from "@cronika/proto/common/common_pb";
import { BetLifecycle } from "@cronika/proto/common/trading_pb";

export const DEFAULT_SIZE = 25;

export const DEFAULT_REQUEST_PARAMS = {
  sortBy: "createdAt",
  sortDir: SortDirection.DESC,
  lifecycle: [BetLifecycle.SETTLED], // По умолчанию показываем закрытые ставки
} as const;

export const INITIAL_PAGINATION = {
  page: 1,
  size: 0,
  total: 0,
} as const;
